import { getActivePage, getSceneNodeChildren, type CurvaDocument } from "@/document/model/document";
import type { SceneNode } from "@/document/model/nodes";
import type { DisplayItem, DisplayList } from "./displayList";

export function expandHiddenSubtreeIds(
  document: CurvaDocument,
  hiddenNodeIds: Set<string>,
  activePageId?: string,
): Set<string> {
  const expanded = new Set<string>();
  const page = getActivePage(document, activePageId);
  if (!page || hiddenNodeIds.size === 0) {
    return expanded;
  }

  function collectSubtree(node: SceneNode): void {
    expanded.add(node.id);
    for (const child of getSceneNodeChildren(node) ?? []) {
      collectSubtree(child);
    }
  }

  function walk(nodes: SceneNode[]): void {
    for (const node of nodes) {
      if (hiddenNodeIds.has(node.id)) {
        collectSubtree(node);
      } else {
        walk(getSceneNodeChildren(node) ?? []);
      }
    }
  }

  walk(page.children);
  return expanded;
}

export function filterDisplayItemsByHiddenIds(items: DisplayItem[], hiddenIds: Set<string>): DisplayItem[] {
  if (hiddenIds.size === 0) {
    return items;
  }

  return items.filter(item => !hiddenIds.has(item.id));
}

export function filterDisplayListByHiddenIds(displayList: DisplayList, hiddenIds: Set<string>): DisplayList {
  return {
    items: filterDisplayItemsByHiddenIds(displayList.items, hiddenIds),
  };
}
